import { Injectable } from '@angular/core';
import { ContentSection, PageContent } from '../models/page-content.model';
import { catchError, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  getPageContent(pageId: string): Observable<PageContent> {
    const currentLang = this.translateService.currentLang || this.translateService.getDefaultLang() || 'en';
    const url = `assets/i18n/${currentLang}/${pageId}.json`;
    
    return this.http.get<any>(url).pipe(
      catchError(error => {
        console.error(`Error loading content for ${pageId}:`, error);
        return of({ title: 'Error', sections: [] });
      })
    );
  }

  getSectionById(pageContent: PageContent, sectionId: string): ContentSection | null {
    if (!pageContent || !pageContent.sections) {
      return null;
    }
    
    // Helper function to find a section by ID
    const findSection = (sections: ContentSection[], targetId: string): ContentSection | null => {
      for (const section of sections) {
        if (section.id === targetId) {
          return section;
        }
        if (section.subsections) {
          const found = findSection(section.subsections, targetId);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    
    return findSection(pageContent.sections, sectionId);
  }

}
